import { useLayoutEffect, useState } from 'react';

const useWindowSize  = () => {
    const [size, setSize] = useState({screenWidth: window.innerWidth, screenHeight: window.innerHeight});
    useLayoutEffect(() => {
        function updateSize() {
            setSize({screenWidth: window.innerWidth, screenHeight: window.innerHeight});
        }

        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);

    return size;
}

export default useWindowSize;